/* eslint-disable react/jsx-indent */
import React, { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import CmsContext from 'context/CmsContext';
import { getInitials } from 'modules/BPLS/applications/helper';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import StudentInformation from './StudentInformation';
import * as action from '../action';
import * as c from '../constant';
import StudentModal from '../modals/StudentModal';

function StudentContent({
  match,
  isLoading,
  permissions,

  showStudent,
  clearStudent,
  studentInfo,


  // approveTransaction,
  // rejectTransaction,

  // transactionInfo,
  onApprove,
  onReject,
  deactivateCitizen
}) {
  const setModal = useContext(ModalContext);
  const selectedStudent = match.params.id;

  const cmsContext = useContext(CmsContext);
  const CMS_VARIABLES = cmsContext.findByType('VARIABLES')

  // const handleApprove = (e) => {
  //   e.preventDefault();

  //   ConfirmAlertWithAmount(
  //     'Are you sure you want to approve this transaction?',
  //     (remarks, amount) => {
  //       approveTransaction(
  //         selectedStudent,
  //         {
  //           remarks,
  //           amount,
  //           module_type: 'STUDENT',
  //         },
  //         () => {
  //           showTransaction(selectedStudent); 
  //         }
  //       );
  //     },
  //     () => {
  //       FormData
  //     },
  //     {
  //       yesLabel: 'Confirm',
  //       noLabel: 'Cancel',
  //     },
  //     true
  //   );
  // };

  // const handleReject = (e) => {
  //   e.preventDefault();
  //   ConfirmAlert(
  //     'Are you sure, you want to Reject this application',
  //     (remarks) => {
  //       rejectTransaction(
  //         selectedStudent,
  //         {
  //           remarks,
  //           status: 'REJECTED',
  //           module_type: 'STUDENT',
  //         },
  //         () => {
  //           showTransaction(selectedStudent);
  //         }
  //       );
  //     },
  //     () => {},
  //     {
  //       yesLabel: 'Confirm',
  //       noLabel: 'Cancel',
  //     },
  //     true
  //   );
  // };

  const updateData = () => {
    showStudent(selectedStudent);
  };

  useEffect(() => {
    if (!_.isEmpty(selectedStudent)) {
      updateData();
    }
    return () => {
      clearStudent();
    };
  }, []);

  useEffect(() => {
    if (!_.isEmpty(selectedStudent)) {
      updateData();
    }
  }, [selectedStudent]);

  const handleEditModal = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <StudentModal
          actionType="EDIT"
          dataInfo={data.attributes}
          id={data.id}
        />
      ),
      title: 'Edit Citizen',
      modalSize: 'modal-lg',
    });
  };

  const handleDeactivateModal = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      <div>
        Are you sure, you want to{' '}
        {_.get(data, 'attributes.is_active') ? 'Deactivate' : 'Activate'} this citizen?
      </div>,
      () => {
        deactivateCitizen(
          selectedStudent,
          {type: 'STUDENT'},
          () => {
            updateData(selectedStudent);
          }
        );
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },   
    );
  };

  // format displayed name: Last, First, Middle
  const firstName = _.get(studentInfo, 'attributes.first_name', " ") || ""
  const lastName = _.get(studentInfo, 'attributes.last_name', "") || ""
  const middleName = _.get(studentInfo, 'attributes.middle_name', " ") || ""
  const extName = _.get(studentInfo, 'attributes.extension_name', " ") || ""

  const isActive = _.get(studentInfo, 'attributes.is_active');

  return (
    <>
      <div className="card-section-content container-fluid">
        {isLoading && (
          <div className="loading">
            <div className="spinner text-center">
              <span className="fas fa-1x fa-spin fa-spinner" />
            </div>
          </div>
        )}
        {/* profile */}
        <div className="px-4 d-flex justify-content-between align-items-center" style={{ fontSize: '24px' }}>
          <div className="p-0 d-flex flex-nowrap w-100">
            <div className="d-flex round-image justify-content-center">
              <h3 className="d-flex align-items-center initials mb-0">
                {_.get(studentInfo, 'attributes.photo') !==
                '-/format/jpeg/' ? (
                  <img
                    alt="Client Profile"
                    src={_.get(studentInfo, 'attributes.photo')}
                  />
                ) : (
                  getInitials(
                    `${_.get(studentInfo, 'attributes.first_name')} ${_.get(
                      studentInfo,
                      'attributes.middle_name'
                    )} ${_.get(studentInfo, 'attributes.last_name')}`
                  )
                )}
              </h3>
            </div>
            <div className="d-flex flex-column ml-4 justify-content-center align-items-start">
              <h1 className="transaction-company m-0">
                {lastName && firstName ? `${lastName}, ` : `${lastName} `}
                {firstName && middleName ? `${firstName} ` : `${firstName} `}
                {middleName && extName ? `${middleName} ` : `${middleName} `}
                {extName}
              </h1>
              <div className='label-title mt-1'>{`${_.get(studentInfo, 'attributes.mobile_number') || ''}`}</div>
            </div>
          </div>
          <div className='py-4'>
            {(isActive && Acl(permissions, ['SOCIAL AMELIORATION STUDENT DEACTIVATE']) || 
            !isActive && Acl(permissions, ['SOCIAL AMELIORATION STUDENT ACTIVATE'])) && (
              <button
                type="button"
                onClick={handleDeactivateModal(studentInfo)}
                className={`btn ${
                  _.get(studentInfo, 'attributes.is_active')
                    ? 'btn-danger'
                    : 'btn-primary cms-bg-color-primary cms-outline-primary '
                } font-weight-bold px-4 ml-2`}
                style={{ width: '164px', height: "32px" }}
              >
                {isActive
                  ? 'Deactivate'
                  : 'Activate'}
              </button>
            )}
          </div>
          {/* Edit Citizen */}
          <div className="py-4">
            {Acl(permissions, ['SOCIAL AMELIORATION STUDENT EDIT']) && (
              <button
                type="button"
                onClick={handleEditModal(studentInfo)}
                className="btn btn-success font-weight-bold px-4 ml-2"
                style={{ width: '164px', height: "32px" }}
              >
                <i className="fas fa-plus" /> &nbsp;&nbsp;
                Edit Information
              </button>
            )}
          </div>
        </div>
        <div className="mb-4">
          {/* GRAY HIGHLIGHT */}
          <div className="row highlight d-flex align-items-center mx-3">
            <div className="col-12 px-0 mt-0 mb-1">
              {/* BORDER */}
              <div className="card border-primary">
                <div className="container-fluid py-1">
                  {/* Action buttons on top */}
                  <div className={`d-flex ml-auto justify-content-end mb-3 ${_.get(CMS_VARIABLES, 'LGU_NAME') === 'City of Borongan'}` && 'd-none'}>
                    {_.get(CMS_VARIABLES, 'LGU_NAME') !== 'City of Borongan' && (
                      <div className="d-flex flex-row justify-content-center align-items-center mr-4" style={{ height: '40px'}}>
                        <label className="alert" style={{ marginBottom: '0'}}>
                          <b>Amount: </b>
                        </label>
                        <div className="alert alert-info" style={{ marginBottom: '0'}}>
                          {_.get(studentInfo, 'attributes.amount') || '- -'}
                        </div>
                      </div>
                    )}
                    {_.get(CMS_VARIABLES, 'LGU_NAME') !== 'City of Borongan' && (
                      <button
                        type="button"
                        onClick={onApprove(studentInfo)}
                        className="gen-btn btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold mr-2"
                      >
                        {isLoading ? (
                          <i className="fa fa-spin fa-spinner" />
                        ) : (
                          <>
                            Approve <i className="fas fa-check ml-1" />
                          </>
                        )}
                      </button>
                    )}
                    {_.get(CMS_VARIABLES, 'LGU_NAME') !== 'City of Borongan' && (
                      // reject
                      <button
                        type="button"
                        onClick={onReject(studentInfo)}
                        className="gen-btn btn btn-danger font-weight-bold"
                      >
                        {isLoading ? (
                          <i className="fa fa-spin fa-spinner" />
                        ) : (
                          <>
                            Reject <i className="fas fa-times ml-1" />
                          </>
                        )}
                      </button>
                    )}
                  </div>
                  <hr />
                  <StudentInformation
                    studentInfo={studentInfo}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

StudentContent.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool.isRequired,
  permissions: PropTypes.instanceOf(Object).isRequired,

  // transactionInfo: PropTypes.instanceOf(Object).isRequired,

  clearStudent: PropTypes.instanceOf(Function).isRequired,
  studentInfo: PropTypes.instanceOf(Object).isRequired,
  showStudent: PropTypes.instanceOf(Function).isRequired,

  // approveTransaction: PropTypes.instanceOf(Function).isRequired,
  // rejectTransaction: PropTypes.instanceOf(Function).isRequired,
  onApprove: PropTypes.instanceOf(Function).isRequired,
  onReject: PropTypes.instanceOf(Function).isRequired,
  deactivateCitizen: PropTypes.instanceOf(Function).isRequired
};

const mapStateToProps = ({ api }) => ({
  permissions: getJson('permissions'),

  // transactionInfo: _.get(api, `${c.SHOW_INCIDENT}.item`) || {},

  studentInfo: _.get(api, `${c.SHOW_STUDENT}.item`) || {},
  isLoading: api.loading.indexOf(c.SHOW_STUDENT) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, action)]);

export default enhance(StudentContent);
